<template>
  <div class="pa-sm-5 facility-info-tab">
    <v-tabs
        v-model="currentTab"
        hide-slider
        background-color="transparent"
        class="info-tab"
        active-class="active-info-tab"
        show-arrows
    >
      <!-- TODO add real progress score when implemented in backend -->
      <!-- Facility Info Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/technical`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(100)">elevator</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:common.facility-info')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(100)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- Contract Tab -->
      <v-tab v-if="this.showContracts" :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/contracts`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(contractScore)">developer_board</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:contract_plural')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(contractScore)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- Docu Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/documentations`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(docuScore)">description</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:documentation_plural')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(docuScore)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- Task-Docu Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/task-documentations`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(docuScore)">task</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:documentation_task_plural')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(docuScore)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- Role Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/roles`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(roleScore)">engineering</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:role_plural')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(roleScore)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- Process Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/processes`" class="mr-4">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(100)">account_tree</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('common:process_plural')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(100)"></v-progress-linear>
        </v-card>
      </v-tab>

      <!-- State Tab -->
      <v-tab :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/state`">
        <v-card elevation="0">
          <v-card-title class="pa-2">
            <div class="d-block">
              <v-icon :color="infoTabCardColor(100)">insights</v-icon>
            </div>
            <div class="d-block">
              <span class="text-subtitle-1" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('book/facility:common.facility-state')}}</span>
            </div>
          </v-card-title>
          <v-card-subtitle class="pa-2">
            {{ $t('book/facility:facility.dashboard.information.bar-description')}}
          </v-card-subtitle>
          <v-progress-linear height="6" value="100" :color="infoTabCardColor(100)"></v-progress-linear>
        </v-card>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <!-- Technical Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/technical`"
          class="pt-10"

      >
        <FacilityTechnicalInfoTab/>
      </v-tab-item>
      <!-- Contracts Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/contracts`"
          class="pt-10"
          eager
      >
        <FacilityContractInfoTab
            ref="contractTab"
            @updateQuicklinkContracts="$emit('updateQuicklinkContracts')"
            @updateContractScore="updateContractScore"
            @changedItem="() => this.contractUpdated = true"
        />
      </v-tab-item>

      <!-- Documentations Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/documentations`"
          class="py-5"
          eager
      >
        <FacilityDocuInfoTab
            ref="docuTab"
            @updateQuicklinkDocus="$emit('updateQuicklinkDocus')"
            @deletedItem="() => $refs.contractTab.callUpdateTable()"
            @updateDocuScore="updateDocuScore"
            @deleteGbuReport="deleteGbuReport($event)"
            :show-contracts="this.showContracts"
        />
      </v-tab-item>

      <!-- Task-Documentations Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/task-documentations`"
          class="py-5"
          eager
      >
        <FacilityTaskDocumentationTab
          ref="facilityTaskDocumentationTab" />
      </v-tab-item>

      <!-- Roles Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/roles`"
          class="py-5"
          eager
      >
        <FacilityRoleInfoTab
            ref="roleTab"
            @updateQuicklinkRoles="$emit('updateQuicklinkRoles')"
            @updateRoleScore="updateRoleScore"/>
      </v-tab-item>
      <!-- Processes Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/processes`"
          class="py-5"
          eager
      >
        <FacilityProcessInfoTab ref="processTab" @updateQuicklinkProcesses="$emit('updateQuicklinkProcesses')"/>
      </v-tab-item>

      <!-- State Tab -->
      <v-tab-item
          :value="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/state`"
          class="py-5"
          eager
      >
        <FacilityStateInfoTab ref="stateTab"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>

import FacilityTechnicalInfoTab from '../facilityInfoTabs/FacilityTechnicalInfoTab'
import FacilityContractInfoTab from '../facilityInfoTabs/FacilityContractInfoTab'
import FacilityRoleInfoTab from '../facilityInfoTabs/FacilityRoleInfoTab'
import FacilityProcessInfoTab from '../facilityInfoTabs/FacilityProcessInfoTab'
import FacilityDocuInfoTab from '../facilityInfoTabs/FacilityDocuInfoTab'
import DesignUtils from "@/modules/core/services/design-utils";
import FacilityStateInfoTab from "@/modules/book/views/facility/facility/facilityInfoTabs/FacilityStateInfoTab";
import FacilityTaskDocumentationTab
  from '@/modules/book/views/facility/facility/facilityInfoTabs/FacilityTaskDocumentationTab';
import facilityService from "@/modules/book/services/facility-service";

export default {
  name: 'FacilityInfoTab',
  components: {
    FacilityTaskDocumentationTab,
    FacilityStateInfoTab,
    FacilityTechnicalInfoTab,
    FacilityContractInfoTab,
    FacilityRoleInfoTab,
    FacilityProcessInfoTab,
    FacilityDocuInfoTab
  },
  data() {
    return {
      currentTab: '',
      docuScore: null,
      roleScore: null,
      contractScore: null,
      contractUpdated: false,
      showContracts: true
    }
  },
  created() {
    if (this.$route.params.id !== undefined) {
      facilityService.checkForUserFacilityPriviledgesNotUserAssignment(this.$route.params.id,
          (success) => {
            this.showContracts = success.data;
      },      (error) => {
            this.$logger.error("checkForUserFacilityPriviledgesNotUserAssignment failed, because: " + error);
            this.showContracts = false;
      })
    }
  },
  watch: {
    currentTab() {
      if(this.contractUpdated && this.currentTab.indexOf('info/documentations') >= 0) {
        this.$refs.docuTab.callUpdateTable();
        this.contractUpdated = false;
      }
    }
  },
  methods: {
    viewDocument(item) {
      if(this.$route.path !== `/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${this.$route.params.id}/info/documentations`) {
        this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${this.$route.params.id}/info/documentations`);
      }

      this.$refs.docuTab.viewDocumentation(item)
    },
    deleteGbuReport(id) {
      this.$refs.stateTab.deleteGbuReportId(id);
    },
    addDocu() {
      this.$refs.docuTab.openFormDialog();
    },

    updateDocuScore(score) {
      this.docuScore = score;
      this.$emit("updateDocuScore", score);
    },

    addRole() {
      this.$refs.roleTab.$refs.roleForm.dialog = true
    },

    updateRoleScore(score) {
      this.roleScore = score;
      this.$emit("updateRoleScore", score);
    },

    addProcess() {
      this.$refs.processTab.openFormDialog();
    },

    addContract() {
      this.$refs.contractTab.openFormDialog();
    },

    updateContractScore(score) {
      this.contractScore = score;
    },

    infoTabCardColor(value) {
      return DesignUtils.getProgressColor(value, null, null, null, null);
    }
  }
}
</script>
<style lang="scss">
.facility-info-tab {
  // make z-index of overlay of delete-twoButtonDialog higher than sub app-bar
  .v-overlay.v-overlay--active.theme--dark  {
    z-index: 402!important
  }
}

</style>